export const registrationForm = {
  registrationAlias: "Alias",
  registrationName: "Nombre",
  registrationLastName: "Apellido",

  registrationEmail: "Correo Electrónico",
  registrationEmail_message: "Por favor ingresa un correo válido",
  registrationEmail_required: "El correo es obligatorio",
  registrationEmail_specialChar:
    "Caracteres especiales no permitidos, Apóstrofo, Comillas, Acento, Letra eñe (ñ), etc.",
  registrationEmail_CharStartEnd: "El correo no puede empezar o terminar con caracteres especiales",
  registrationEmail_CharConsecutive: "El correo no puede tener caracteres especiales consecutivos",

  registrationPhoneNumber: "Teléfono",
  registrationPhoneNumber_message: "Por favor, introduzca un número de teléfono válido",
  registrationPhoneNumber_tooltip: "El teléfono registrado será usado para validar los pago móvil.",
  registrationBirthdate: "Fecha de Nacimiento",
  registrationBirthdate_message: "Debes ser mayor de 18 años para registrarte",
  registrationNational_id: "Cédula",
  registrationId_message: "Por favor ingresa su cedula",
  registrationNationalIdNumbersOnly: "Solo se permiten números del 0 al 9",
  registrationState: "Estado",
  registrationSelect_state: "Seleccione un Estado",
  registrationCity: "Ciudad",
  registrationSelect_city: "Seleccione una Ciudad",
  registrationSelectDate: "Fecha de Nacimiento",
  registrationPassword: "Contraseña",
  registrationPasswordMinLength: "La contraseña debe tener al menos 8 caracteres",
  registrationRepeatPassword: "Repetir Contraseña",
  registrationRepeatPassword_required: "Por favor repita su contraseña",
  registrationPasswordNotMatch: "Las contraseñas no coinciden",
  registrationReferralCode: "Código de Referido (opcional)",
  registrationTermsAndConditions: "términos y condiciones",
  registrationTermsAndConditions_: "Acepto los",
  registrationAcceptTerms: "Debes aceptar los términos y condiciones",
  registrationAcceptTermsAgeCondition: "y confirmo ser mayor de 18 años",
  registrationAcceptTermsRegister: "Registrarse",

  registrationAliasUnavailable: "Este alias ya está en uso, prueba con otro",
  registrationAliasChecking: "Verificando disponibilidad del alias...",
  registrationAliasAvailable: "Este alias está disponible",

  registrationAccountValidationModal: "Error de Registro",
  registrationValidationModalEmail:
    "Este usuario ya se encuentra registrado en el sistema. Por favor, inicie sesión o utilice una dirección de correo electrónico diferente para registrarse.",
  registrationValidationModalPhone: "Teléfono ya registrado, por favor utilice otro número de teléfono.",
  registrationValidationModalId: "Cédula ya registrada, por favor utilice otra cédula.",
  registrationValidationModalError: "Hubo un error, por favor verifique sus datos.",
  registrationBonusTitle: "Bono de preferencia",
  registrationFormBonusSlot: "Slots",
  registrationFormBonusCasino: "Casino en vivo",
  registrationFormBonusParley: "Parley",

  registrationSuccessTitle: "¡Registro Exitoso!",
  registrationSuccessMessage: "¡Bienvenido! Has sido automáticamente conectado.",
  registrationError: "Error en el Registro",
  registrationErrorMessage:
    "El registro se completó pero no pudimos iniciar sesión automáticamente. Por favor, inicia sesión manualmente.",
};
